import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PropertyFilters from "@/components/PropertyFilters";
import { useLocations } from "@/hooks/useLocations";
import { useNavigate } from "react-router-dom";
import { defaultPropertySearchFilters, filtersToSearchParams, type PropertySearchFilters } from "@/lib/propertyFilters";
import { useState } from "react";
import PropertiesForSale from "@/components/PropertiesForSale";
import PropertiesForRent from "@/components/PropertiesForRent";
import ServicesSection from "@/components/ServicesSection";
import LocationsSection from "@/components/LocationsSection";
import OffPlanInvestments from "@/components/OffPlanInvestments";
import AboutSection from "@/components/AboutSection";
import BlogSection from "@/components/BlogSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import FloatingContactIcons from "@/components/FloatingContactIcons";

const Index = () => {
  const navigate = useNavigate();
  const { data: locations = [], isLoading: loadingLocations } = useLocations();
  const [filters, setFilters] = useState<PropertySearchFilters>(defaultPropertySearchFilters);

  return (
    <div className="bg-brand-canvas min-h-screen">
      <Header />
      <main className="w-full">
        <HeroSection />
        
        {/* Search Filters Section */}
        <div className="relative z-10 w-full px-6 md:px-16 -mt-20 animate-fade-up">
          <div className="max-w-6xl mx-auto bg-foreground/95 backdrop-blur-md rounded-lg p-4 md:p-6">
            <PropertyFilters
              value={filters}
              locations={locations}
              loadingLocations={loadingLocations}
              onChange={setFilters}
              onSubmit={() => navigate(`/search-results?${filtersToSearchParams(filters).toString()}`)}
              onReset={() => setFilters(defaultPropertySearchFilters)}
              submitLabel="Search"
              theme="hero"
            />
          </div>
        </div>
        <PropertiesForSale />
        <PropertiesForRent />
        <ServicesSection />
        <LocationsSection />
        <OffPlanInvestments />
        <AboutSection />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingContactIcons />
    </div>
  );
};

export default Index;
